<svg
    [attr.width]="size()"
    [attr.height]="size()"
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.99902 3.99805L1.99902 11.998L9.99902 19.998"
        stroke="#1D53A4"
        stroke-width="2"
        stroke-linecap="round" />
</svg>
